/* eslint-disable */
export default {
  from: '발신자',
  to: '수신자',
  enterNameOrNumber: '번호 또는 이름 입력...',
  typeMessage: '메시지 입력...',
  send: '전송',
  emoji: '이모지',
} as const;

// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number or Name..."@#@
// @key: @#@"typeMessage"@#@ @source: @#@"Type message..."@#@
// @key: @#@"send"@#@ @source: @#@"Send"@#@
// @key: @#@"emoji"@#@ @source: @#@"Emoji"@#@
